var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcForceRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18.813,
    viewBox: "0 0 22 18.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_force_refresh",
    transform: "translate(0 -1.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9955",
    "data-name": "Path 9955",
    d: "M22,11.5c-1.3,1.9-2.6,3.8-4,5.7a.841.841,0,0,1-1.4,0c-1.3-1.8-2.6-3.7-3.8-5.5a.908.908,0,0,1,0-1,.751.751,0,0,1,1-.2,2.186,2.186,0,0,1,.5.3,2.186,2.186,0,0,1,.5.3h0a9.253,9.253,0,0,0-.2-2.9,5.9,5.9,0,0,0-4.2-3.9,5.8,5.8,0,0,0-3.2,0,.8.8,0,0,1-1-1c0-.1.2-.3.3-.4a9.123,9.123,0,0,1,4.8-1.3,8.66,8.66,0,0,1,5.5,2.2,9.24,9.24,0,0,1,2.8,5.1,13.4,13.4,0,0,1,.1,2v.3c.3-.2.7-.3,1-.5a.843.843,0,0,1,1.3.4C22,11.2,22,11.4,22,11.5Z",
    fill: "#54bafe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9956",
    "data-name": "Path 9956",
    d: "M0,10.5C1.3,8.6,2.6,6.7,4,4.8a.841.841,0,0,1,1.4,0C6.7,6.6,8,8.5,9.2,10.3a.9.9,0,0,1,0,1,.758.758,0,0,1-1,.1,9.292,9.292,0,0,0-1-.5h0a8.879,8.879,0,0,0,.1,2.3,5.677,5.677,0,0,0,3.1,4.1,5.443,5.443,0,0,0,2.7.7,5.663,5.663,0,0,0,1.8-.3.819.819,0,0,1,1,.4.731.731,0,0,1-.4,1,8.291,8.291,0,0,1-4.8,1.3,8.948,8.948,0,0,1-5.2-1.9,8.469,8.469,0,0,1-3-4.6,19.67,19.67,0,0,1-.3-2.4v-.6a7.255,7.255,0,0,0-.9.5A.843.843,0,0,1,0,11C0,10.8,0,10.6,0,10.5Z",
    fill: "#54bafe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcForceRefresh);
export default __webpack_public_path__ + "static/media/ic_force_refresh.2c4864e3f237c2f0c4fd13f39c079197.svg";
export { ForwardRef as ReactComponent };